import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Slider from './components/Slider';
import Hero from './components/Hero';
import Features from './components/Features';
import FAQs from './components/FAQs';
import Footer from './components/Footer';
import Signup from './components/Signup';
import Modal from './components/Modal';
import ContactForm from './components/ContactForm';
import FloatingContactButton from './components/FloatingContactButton';
import ScrollToTop from './components/ScrollToTop';
import TrustTestimonials from './components/TrustTestimonials';
import ScrollToTopButton from './components/ScrollToTopButton';
import Pricing from './components/Pricing';
import SpecialOfferModal from './components/SpecialOfferModal';
import BlogList from "./components/Blog/BlogList";
import BlogDetail from "./components/Blog/BlogDetail";


function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>

      {/* Header with contact trigger */}
      <Header openModal={openModal} />
      <ScrollToTop />

      {/* Route Pages */}
      <Routes>
        <Route
          path="/"
          element={
            <>
          <SpecialOfferModal /> {/* 👈 only shown on home page */}
              <Slider />
              <Hero />
              <TrustTestimonials />
              <FAQs />
              <div className="flex justify-center my-6">
                <button
                  onClick={openModal}
                  className="bg-orange-500 text-white py-2 px-6 rounded hover:bg-orange-600 transition"
                >
                  Contact for Demo
                </button>
              </div>
            </>
          }
        />
        <Route path="/signup" element={<Signup />} />
        {/*<Route path="/pricing" element={<Pricing />} />*/}
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/features" element={<Features />} />
        <Route path="*" element={<h1 className="text-center text-2xl mt-10">Page Not Found</h1>} />
         {/* 👇 add blog routes */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>

      {/* Footer and other fixed components */}
      <Footer />
      <FloatingContactButton onClick={openModal} />
      <ScrollToTopButton />
      {isModalOpen && <Modal closeModal={closeModal} />}
      
    </>
  );
}

export default App;
